import script from "./PostalCodeSuggest.vue?vue&type=script&setup=true&lang=ts"
export * from "./PostalCodeSuggest.vue?vue&type=script&setup=true&lang=ts"

import "./PostalCodeSuggest.vue?vue&type=style&index=0&id=2ab253e5&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ab253e5"]])

export default __exports__